export enum StorageKey {
    SESSION_CONTEXT = 'ngStorage-sessionContext',
    SERVICE_GROUP_ID = 'ngStorage-serviceGroupId',
    VERIFIED_ADDRESS = 'ngStorage-verifiedAddress',
    AVAILABLE_PRODUCTS = 'ngStorage-availableProducts',
    PRODUCT_CONFIG = 'ngStorage-productConfig',
    SELECTED_PRODUCT = 'ngStorage-selectedProduct',
    PRODUCT_CONFIG_STEPS = 'ngStorage-productConfSteps',
    SEARCH_UUID = 'ngStorage-searchResultUuid',
    CHECKOUT_TYPE = 'ngStorage-checkoutType',
}
